// src/components/Sidebar.js
import React, { useState } from "react";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

const Sidebar = ({ onNewChat }) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleSidebar = () => setIsOpen((prev) => !prev);

  return (
    <>
      {/* Hamburger Icon */}
      <div className="hamburger-icon" onClick={toggleSidebar}>
        {isOpen ? <CloseIcon /> : <MenuIcon />}
      </div>

      {/* Sidebar */}
      <div className={`sidebar ${isOpen ? "open" : ""}`}>
        <button
          className="new-chat"
          style={{ marginTop: "150px" }}
          onClick={() => {
            onNewChat();
            setIsOpen(false); // close after starting new chat
          }}
        >
          + New chat
        </button>
      </div>
    </>
  );
};

export default Sidebar;
